import { STORAGE_KEY, type TransferData } from '../../constants'

function parseStoredData (): TransferData | null {
  const raw = GM_getValue(STORAGE_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as TransferData
  } catch {
    return null
  }
}

function hasNoSearchResult (): boolean {
  const text = document.body?.innerText || ''
  const markers = [
    'There\'s nothing on The StoryGraph matching',
    'If needed, you can manually add a book to our database.',
    'No books found',
    'No results',
    'Try searching for a different title',
    '0 books'
  ]

  return markers.some((marker) => text.includes(marker))
}

function fallbackKey (data: TransferData, step: string): string {
  // Scope by ISBN so fallback chain is unique per book
  return `sg_fallback_${encodeURIComponent(data.isbn)}_${step}`
}

export function maybeFallbackToOriginalTitleSearch (): void {
  const url = new URL(window.location.href)
  if (url.pathname !== '/browse') return

  const searchTerm = (url.searchParams.get('search_term') || '').trim()
  if (!searchTerm) return

  const data = parseStoredData()
  if (!data?.isbn) return
  if (!hasNoSearchResult()) return

  // Step 1: searched by ISBN, no results → try title
  if (searchTerm === data.isbn && data.title && data.title !== data.isbn) {
    const doneKey = fallbackKey(data, 'title')
    if (sessionStorage.getItem(doneKey) === '1') return
    sessionStorage.setItem(doneKey, '1')
    const nextUrl = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(data.title)}`
    window.location.assign(nextUrl)
    return
  }

  // Step 2: searched by title, no results → try originalTitle
  if (searchTerm === data.title && data.originalTitle && data.originalTitle !== data.title) {
    const doneKey = fallbackKey(data, 'orig')
    if (sessionStorage.getItem(doneKey) === '1') return
    sessionStorage.setItem(doneKey, '1')
    const nextUrl = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(data.originalTitle)}`
    window.location.assign(nextUrl)
    return
  }
}
